import { FC, useState, useEffect } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./ReasonForNoCategory.module.sass";
import { Radio } from "components-new";
import { Modal } from "components-new";
import cn from "classnames";
import { useAppSelector } from "toolkit/hooks";

interface ReasonForNoCategoryProps {
	mode:"reason" | "radioCat" | null
	handleModalClose: () => void;
	setSelectedReason:  (React.Dispatch<React.SetStateAction<{mode: "reason" | "radioCat" | null, reason: {id: number, name: string} | null}>>) | Function;
	candidate: any;
}

const ReasonForNoCategory: FC<ReasonForNoCategoryProps> = ({ handleModalClose, setSelectedReason,mode, candidate }) => {
	const reasons = useAppSelector((state) => state.selectionCategories.reasons);
	const [reason, setReason] = useState<any>();

	const selectReason = () => {
		console.log('call')
		mode === 'reason' ? setSelectedReason(prevState => ({mode, reason})) : setSelectedReason(reason)
	};
	const handleClose = () => handleModalClose();

	const [initialValue, setInitialValue] = useState<{ id: number; name: string } | null>();

	useEffect(() => {
		setInitialValue(mode === 'reason'?candidate.customCat:candidate.applicabilityCat);
		//eslint-disable-next-line
	}, []);

	return (
		<Modal handleClose={handleClose}>
			<div className={styles.title}>Выберите причину отсутствия категорий значимости</div>
			<div className={styles.reasonsList}>
				{reasons.map((reason) => (
					<Radio
						className={cn(styles.reason, {
							[styles.selected]: initialValue?.id === reason.id,
						})}
						label={reason.name}
						name="reason"
						value={reason.id}
						checked={initialValue?.id === reason.id}
						handleSelected={() => {
							setInitialValue(reason);
							setReason(reason);
						}}
						key={reason.id}
					/>
				))}
			</div>

			<div className={styles.buttons}>
				<Button full variant={BUTTON_VARIANTS.OUTLINED} onClick={handleClose}>
					Отменить
				</Button>
				<Button
					full
					onClick={() => {
						if (!reason) {
							handleClose();
							return;
						}
						selectReason();
						handleClose();
					}}>
					Готово
				</Button>
			</div>
		</Modal>
	);
};

export default ReasonForNoCategory;
